import { Button as BButton, type ButtonProps as Props, cn } from "@coideo/barrani";

const KINDS = {
  primary: {
    bg: "bg-primary-600",
    button: "text-white hover:bg-primary-700 disabled:bg-primary-600",
    loading: "bg-white",
  },
  secondary: {
    bg: "bg-primary-100",
    button: "text-primary-700 hover:bg-primary-200 disabled:bg-primary-100",
    loading: "bg-primary-700",
  },
  tertiary: {
    bg: "bg-white",
    button:
      "text-primary-700 border-0 hover:bg-primary-50 disabled:bg-white ring-1 ring-inset ring-primary-300 focus:!ring-offset-0",
    loading: "bg-primary-700",
  },
  link: {
    bg: "shadow-none",
    button: "text-primary-600 hover:text-primary-500 disabled:bg-primary-100",
    loading: "bg-primary-700",
  },
  light: {
    bg: "bg-white",
    button: "border-gray-400 text-gray-700 hover:bg-gray-100 disabled:bg-gray-200",
    loading: "bg-gray-700",
  },
  edit: {
    bg: "bg-gray-50",
    button:
      "text-gray-700 hover:bg-white !shadow-none hover:!shadow-sm hover:border-gray-100 disabled:bg-gray-200",
    loading: "bg-gray-700",
  },
  cash: {
    bg: "bg-green-600",
    button: "text-white hover:bg-green-700 disabled:bg-green-600",
    loading: "bg-white",
  },
};

export type ButtonProps = Omit<Props, "kind"> & {
  kind?: keyof typeof KINDS;
};

export default function Button({ className, kind = "primary", ...props }: ButtonProps) {
  const k = KINDS[kind];

  return <BButton className={cn(className, "focus:ring-primary-500")} kind={k} {...props} />;
}
